import React from 'react';
import { withNamespaces, WithNamespaces } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
} from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import { Button, MFGIcon } from '@syncfab/machine';
import WarningIcon from '@mui/icons-material/Warning';

import { SendMFGTokensForm } from './SendMFGTokensForm';
const styles = theme => ({
  table: {},
  paper: {
    width: '90%',
    minWidth: 300,
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  paper2: {
    width: '80%',
    minWidth: 300,
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  gridPadding: {
    padding: `${theme.spacing(2)} ${theme.spacing(20)}`,
  },
  balanceContainer: {
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: 15,
    margin: `${theme.spacing(2)} ${theme.spacing(1)}`,
    padding: theme.spacing(2),
  },
  mfgIcon: {
    width: 75,
    height: 75,
  },
  balance: {
    color: theme.palette.secondary.main,
    fontSize: 34,
    marginLeft: theme.spacing(1),
  },
  margin: {
    margin: theme.spacing(1),
  },
  paragraph: {
    color: '#f55c47',
  },
  title: {
    marginBottom: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },

  warningButton: {
    color: '#ef5350',
    margin: theme.spacing(1),
    fontSize: 64,
  },
  errorButton: {
    color: '#ef5350',
    margin: theme.spacing(2),
    fontSize: 64,
  },
  walletIcon: {
    color: theme.palette.common.white,
    margin: theme.spacing(2),
    fontSize: 64,
    backgroundColor: '#FFBA00',
  },
  processingButton: {
    color: '#40BF8A',
    margin: theme.spacing(2),
    fontSize: 64,
  },
  root: {
    backgroundColor: theme.palette.common.white,
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    color: theme.palette.grey['700'],
  },

  horizontalheader: {
    backgroundColor: theme.palette.grey['300'],
    width: '35%',
    fontWeight: 900,
    // padding:`${theme.spacing.unit * 2}px 0`
  },
  link: {
    color: '#40B4BF',
    textDecoration: 'none',
  },

  tablePagination: {},
  tablePaginationCaption: {
    color: 'white',
  },
  tablePaginationSelectIcon: {
    color: 'white',
  },

  tablePaginationSelect: {
    color: 'black',
  },
  tablePaginationActions: {
    color: 'white',
  },

  tablePaginationNextIcon: {
    color: 'white !important',
  },
  tablePaginationBackIcon: {
    color: 'white !important',
  },

  refresh: {
    color: theme.palette.common.white,
  },
  refreshIcon: {
    marginLeft: theme.spacing(1),
  },
  marginTextRight: {
    marginRight: theme.spacing(2),
  },
  marginTextBottom: {
    marginBottom: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },
  links: {
    marginLeft: theme.spacing(0.5),
    'text-decoration': 'none',
    'text-transform': 'none',
    color: theme.palette.primary.light,
  },
  marginTop: {
    marginTop: theme.spacing(3),
  },
  errormsg: {
    backgroundColor: '#8E7931',
    'border-left-color': '#FFC525',
    'border-left-style': 'solid',
    'border-left-width': 'thick',
  },
  colorWhite: {
    color: 'white !important',
    fontSize: theme.spacing(1.8),
  },
  warningIcon: {
    color: theme.palette.common.white,
    margin: theme.spacing(0.5),
  },
  wrapIcon: {
    verticalAlign: 'middle',
    display: 'inline-flex',
  },
  dialogClass: {
    padding: theme.spacing(3),
  },
  dialogTitleClass: {
    paddingBottom: theme.spacing(1.7),
  },
  marginTopCopyText: {
    marginTop: theme.spacing(1.7),
  },
  heading: {
    fontSize: '24px',
    fontWeight: 600,
  },
  subtitle: {
    fontSize: '36px',
    color: 'white !important',
    letterSpacing: '0.5px !important',
    fontWeight: 400,
  },
  contactButton: {
    letterSpacing: '1px',
  },
});
interface SendTokensProps extends WithNamespaces, WithStyles<typeof styles> {
  open: boolean;
  close: () => void;
  onSubmit: () => void;
  balance?: any;
  onSendToken: (data: any) => void;
}
const dialog = ({
  onSubmit,
  onSendToken,
  open,
  close,
  balance,
  classes,
  t,
}: SendTokensProps) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="address-dialog-title"
      onClose={close}
      fullWidth
      classes={{ paper: classes.dialogClass }}
    >
      <DialogTitle id="simple-dialog-title" className={classes.title}>
        <Typography style={{ fontSize: '24px', fontWeight: 600 }}>
          {' '}
          Send MFG Tokens
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography>
          A MFG transaction fee is charged for any send request. This
          transaction fee is used to pay for blockchain miners GAS fee.
          <a
            target="_blank"
            href="https://kb.myetherwallet.com/en/transactions/what-is-gas/"
            className={classes.links}
          >
            {'Learn More'}
          </a>
        </Typography>
        <Typography variant="h3" className={classes.marginTop}>
          Available MFG to send
        </Typography>
        <Grid
          item
          container
          alignItems="center"
          className={classes.balanceContainer}
        >
          <Grid item xs={2}>
            <MFGIcon className={classes.mfgIcon} fill="#FFBA00" />
          </Grid>
          <Grid item xs={10}>
            <Typography gutterBottom variant="h3">
              MFG Balance (Erc721)
            </Typography>
            <Typography gutterBottom className={classes.balance}>
              {balance
                ? balance.MFG_Balance !== null || undefined
                  ? `${balance.MFG_Balance}`
                  : '0'
                : '0'}
            </Typography>
          </Grid>
        </Grid>
        <Typography gutterBottom variant="h3" className={classes.marginTop}>
          Send Details
        </Typography>
        <Grid
          container
          direction="row"
          alignItems="center"
          className={classes.errormsg}
        >
          <Grid item>
            <WarningIcon
              className={classes.warningIcon}
              style={{ fontSize: 18 }}
            />
          </Grid>
          <Grid item>
            <Typography variant="body1">
              Recipient's wallet must support MFG ERC20 or may result in loss of
              MFGs.
            </Typography>{' '}
          </Grid>
        </Grid>

        <SendMFGTokensForm onSubmit={onSubmit} />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="primary" variant="text">
          {t('address-dialog-cancel')}
        </Button>
        <Button onClick={onSendToken} color="primary">
          CONTINUE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const SendTokensDialog = withStyles(styles)(withNamespaces()(dialog));
